import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { Button, CircularProgress, Link, makeStyles } from '@material-ui/core';
import Icon from '@app/components/Icon';

interface IProps {
    className?: string;
    onClick?: () => void;
    isLoading?: boolean;
}
const useStyles = makeStyles({
    root: {
        width: '100%',
        height: '40px',
        textTransform: 'none'
    }
});
const learnMoreK1Link = 'https://help.one.kaseya.com/help/Content/1_Configuration/Log_in_with_K1.htm';

export function KaseyaOne(props: IProps) {
    const { translation } = useTypedTranslation();
    const { className, onClick, isLoading } = props;
    const classes = useStyles(props);

    return (
        <>
            <div className='login__sso-divider'>{translation('KASEYA_ONE_OR_TEXT')}</div>
            <Button
                id='kaseya-one'
                variant='outlined'
                className={className}
                classes={{ root: classes.root }}
                onClick={onClick}
                disabled={isLoading}
                disableRipple={true}
            >
                {isLoading ? (
                    <CircularProgress size='24px' />
                ) : (
                    <>
                        <Icon className='button--kaseya-one-icon' icon='k1Ico' alt='Kaseya One' />
                        <span className='button--kaseya-one-text'>{translation('SIGNIN_KASEYA_ONE_BUTTON')}</span>
                    </>
                )}
            </Button>
            <div className='login__kaseya-one-link-block'>
                <Link href={learnMoreK1Link} className='login__kaseya-one-link' rel='noopener noreferrer' target='_blank' underline='none'>
                    {translation('LEARN_MORE_K1')}
                </Link>
            </div>
        </>
    );
}
